<template>
  <div>
    <div class="banner">
      <span>{{$t("about.banner")}}</span>
    </div>
    <div class="section-wrap ">
      <tabnav :tab="tab"></tabnav>
      <div class="tab-content ">

        <div :class="tab==4?'':'hide'">
          <ul class="clearfix tech-ul">
            <li class="tech-li" v-for="item in patent" >
              <div>
                <div class="tech-li-img" :style="'background:url('+item.frontCover +'?imageView2/2/w/400/interlace/1) no-repeat center/cover'">
                </div>
                <div class="tech-li-info">
                  <div class="c-333 cbg-textOver fl" :title="item.title">{{item.materialName}}</div>
                  <div class="tech-li-btn fr clearfix">
                    <a :href="item.materialDocuments" target="_blank" @click=""><a-icon type="eye" /> 预览</a>
                    <a :download="item.materialName" :href="item.materialDocuments" target="_blank"><a-icon type="cloud-download" /> 下载</a>
                    <!--<a download href="https://pkwb-oos.oss-cn-shenzhen.aliyuncs.com/uploads/peak_taichi/20200516/%E6%80%81%E6%9E%812.0%E7%BA%BF%E7%A8%BF%E5%8E%9F%E5%9E%8B%E5%9B%BE%E5%8F%8A%E4%BD%9C%E5%93%81%E8%A7%84%E8%8C%83.zip" target="_blank"><a-icon type="cloud-download" /> 下载</a>-->
                  </div>
                </div>
              </div>

            </li>
          </ul>

          <div v-show="patent.length==0" class="tc">
            {{$t("common.date_list")}}
            
          </div>
          <div class="pagination clearfix" v-show="patent.length>0">
            <a-pagination :class="$i18n.locale" v-model="listQuery.page" :page-size="listQuery.number" :total="listQuery.total" show-less-items @change="sizeChange"/>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
    import tabnav from './components/tabnav'
    import { selectMaterial } from '@api/index'
  import { mapMutations,mapActions } from 'vuex'


  export default {
    name: 'download',
      components: {tabnav},
    data () {
      return {
          tab:4 ,
          listQuery:{
              number:12,
              page:1,
              totalPage:1,
              total:5
          },
          curImg:'',
          showLayerBig:false,
          patent:[{frontCover: require('@/assets/images/about/download/1.jpg'),materialName:'SensFoot 画册',materialDocuments:'https://pkwb-oos.oss-cn-shenzhen.aliyuncs.com/uploads/peak_taichi/20200604/SensFoot%20%E7%94%BB%E5%86%8C.pdf',label:''},
              // {frontCover:require('@/assets/images/about/download/2.jpg'),materialName:'SF-118 检测报告',file:'https://pkwb-oos.oss-cn-shenzhen.aliyuncs.com/uploads/peak_taichi/20200604/SF-118%20%E6%A3%80%E6%B5%8B%E6%8A%A5%E5%91%8A.pdf',label:''},
              // {frontCover:require('@/assets/images/about/download/3.jpg'),materialName:'SW-02 SW-018 检测报告',file:'https://pkwb-oos.oss-cn-shenzhen.aliyuncs.com/uploads/peak_taichi/20200604/SW-02%20SW-018%20%E6%A3%80%E6%B5%8B%E6%8A%A5%E5%91%8A.pdf',label:''},
              // {frontCover:require('@/assets/images/about/download/4.jpg'),materialName:'SW-020',file:'https://pkwb-oos.oss-cn-shenzhen.aliyuncs.com/uploads/peak_taichi/20200604/SW-020.pdf',label:''},
              // {frontCover:require('@/assets/images/about/download/5.jpg'),materialName:'SW-F21 天祥测试报告',file:'https://pkwb-oos.oss-cn-shenzhen.aliyuncs.com/uploads/peak_taichi/20200604/SW-F21 天祥测试报告.pdf',label:''}

          ],

      }
    },
    created () {

    },
      mounted(){
          this.getList()
          this.listQuery.languageType = this.$i18n.locale
      },
    methods: {
        getList() {
            this.$loading.show()
            selectMaterial(this.listQuery).then(res=>{
                this.$loading.hide()
                if(res.code==0){
                    this.listQuery.total=res.data.total
                    this.listQuery.totalPage=res.data.totalPage
                    this.patent=res.data.list
                }else{
                    this.$message.error(res.msg)
                }
            })
        },
        sizeChange(page,size){
            // console.log(page)
            this.listQuery.page=page
            this.getList()
        }
    }
  }
</script>
<style lang="stylus" scoped>
  @import "~@/assets/css/public.styl"

  .realize-more
    user-select none;cursor pointer
  h2,h3,h4,h5,h6,p{
    margin: 0
  }

  .banner{height:280px;background :url("~@/assets/images/about/banner.jpg") no-repeat center/auto 100%;}
  .tab-nav>div{width:25%;}
    .tab-content{margin-bottom: 1.45rem;}
      .text1{font-size:.16rem;color:#666666;width:6.55rem;margin:0 auto;line-height:.32rem;padding:.43rem 0 .6rem;}

  .video{height:4.4rem;width:100%;display: block; }
  .video{background: url("~@/assets/images/tech/video.png") no-repeat center/cover;border-radius .05rem;}
    .tech-table-w{padding:0 .5rem;padding-bottom 1.2rem;}
    .tech-table{width:100%;background :#f8f8f8;min-height:3rem;}
      .tech-cell{width:50%;vertical-align middle;padding:0.3rem .38rem;position relative;}
.tech-title{font-size:.24rem;}
  .tech-label{font-size:.16rem;padding-bottom .25rem;}
  .tech-text{font-size:.14rem;line-height :.32rem;}
.tech-img1{background: url("~@/assets/images/tech/img1.png") no-repeat center/cover;}
  .tech-img2{background: url("~@/assets/images/tech/img2.png") no-repeat center/cover;}
  .tech-img3{background: url("~@/assets/images/tech/img3.png") no-repeat center/cover;}

    .tech-ul{padding-top:.2rem;}
.tech-li{width:32.24%;margin-right:1.64%;margin-bottom:1.64%;height:3.6rem;
  &>div{padding:0;}
  &:nth-child(3n){margin-right:0;}
  .tech-li-img{height:2.8rem;padding:0;border:0;}
  .tech-li-info{height:.8rem;    padding: 0.22rem 0.2rem;line-height.3rem;0.3rem 0.24rem
    .c-333{width:1.8rem;padding-bottom .22rem;}

  a{font-size:.14rem;color:#666;fl();width:.64rem;line-height.3rem;border:1px solid #ccc;border-radius :.05rem;text-align :center;margin-left:.1rem;}
  }
}

    .tab1{background:#fff;}
  @media screen and (max-width: 768px){
    .section-wrap{padding:0;}
    .banner{height:3.7rem;background url("~@/assets/images/about/m-banner.jpg") no-repeat center/auto 100%;}
    .tab-content{background:#f8f8f8;margin-bottom: .95rem;}
      .tab1{background:#f8f8f8;}
    .text1{font-size:.26rem;width:86%;line-height:.56rem;padding:.55rem 0 .3rem;}
    .video{border-radius:0;}
    .tech-title{font-size:.32rem;}
    .tech-cell{padding: 0.3rem 0.2rem;}
    .tech-table{background:#fff;min-height :4.66rem;}
    .tech-label{font-size:.24rem;padding-bottom .15rem;}
    .tech-text{font-size:.24rem;line-height .4rem;}
    .tech-table-w{padding:0;margin-top:.55rem;}
    .tech-img1{background: url("~@/assets/images/tech/img1-m.png") no-repeat center/cover;}
    .tech-img2{background: url("~@/assets/images/tech/img2-m.png") no-repeat center/cover;}
    .tech-img3{background: url("~@/assets/images/tech/img3-m.png") no-repeat center/cover;}
    .tech-ul{width:93.33%;margin:0 auto;padding-top:.7rem;}
    .tech-li{width:48.57%;margin-right :2.8%;margin-bottom :2.8%;height:4.15rem;
      &:nth-child(3n){margin-right:2.8%;}
      .tech-li-img{height:2.55rem;}
    .tech-li-info{height:1.6rem;
      .c-333{width:100%}
      .tech-li-btn{float :none;text-align center;}
      a{float :none;display :inline-block;font-size:.2rem;width:1.34rem;line-height :.46rem;margin:0;
      &:nth-child(1){float:left;}
  &:nth-child(2){float:right;}
      }
    }

    }
    .tech-li:nth-child(2n){margin-right:0;}
    .pagination{margin-top:.6rem;}
  }
</style>
<style >
  body{background :#f8f8f8}
  </style>
